import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  quantityPerScreen: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_QUANTITY_PER_SCREEN:
      return { ...state, isLoading: true };
    case actionTypes.GET_QUANTITY_PER_SCREEN_FULFILLED:
      return {
        ...state,
        isLoading: false,
        quantityPerScreen: action.payload.quantityPerScreen,
      };
    case actionTypes.GET_QUANTITY_PER_SCREEN_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
